import React from 'react'
import { useTranslation } from 'react-i18next'
import BlogLink from 'client/components/core/Sidebar/components/Settings/components/BlogLink'

interface LinkSourceBlogProps {
  url?: string
  update: (url: string) => void
}

export const LinkSourceBlog = ({ url, update }: LinkSourceBlogProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-between px-6 py-3">
      <label htmlFor="blog-link-input" className="block text-heading-5">
        {t('components.core.text_editor.link_toolbar.blog_link')}
      </label>
      <BlogLink
        className="w-2/3 text-left"
        blogLink={url || ''}
        update={update}
      />
    </div>
  )
}
